
{
  "familyId": "MET-OPP-VIERKANT",
  "questions": [
    {
      "id": "MET-OPP-VIERKANT-001",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "multiple_choice",
      "question": "Een schilder moet een vierkant wandpaneel verven. De zijden zijn 6 cm op de schets. Wat is de oppervlakte?",
      "options": ["36 cm²", "24 cm²", "12 cm²", "42 cm²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geo",
          "data": {
            "shape": "square",
            "width": 6,
            "height": 6,
            "unit": "cm",
            "showGrid": true,
            "label": "Vierkant: 6 × 6 cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte vierkant",
            "content": "Formule: oppervlakte = zijde × zijde. Een vierkant heeft 4 gelijke zijden. Dus: 6 × 6 = 36 cm².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "square_area_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "De oppervlakte van een vierkant = zijde × zijde. De zijde is 6 cm, dus: 6 × 6 = 36 cm².",
        "solutionSteps": [
          "Lees de zijde af: 6 cm",
          "Gebruik de formule: oppervlakte = zijde × zijde",
          "Reken uit: 6 × 6 = 36 cm²"
        ],
        "distractorExplanations": {
          "0": "Goed! 6 × 6 = 36 cm².",
          "1": "Je dacht waarschijnlijk dat je de omtrek moest berekenen. 24 cm is de omtrek (4 × 6 = 24), niet de oppervlakte. Onthoud: oppervlakte = zijde × zijde, omtrek = 4 × zijde.",
          "2": "Je dacht waarschijnlijk dat je 6 × 2 moest rekenen. Maar bij oppervlakte vermenigvuldig je de zijde met zichzelf: 6 × 6 = 36. Onthoud: oppervlakte = zijde × zijde, niet zijde × 2.",
          "3": "Je dacht waarschijnlijk dat 6 × 7 = 42. Maar een vierkant heeft gelijke zijden, dus je rekent 6 × 6 = 36. Onthoud: controleer altijd je vermenigvuldiging."
        }
      }
    },
    {
      "id": "MET-OPP-VIERKANT-002",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "multiple_choice",
      "question": "Een tuinarchitect ontwerpt een vierkante tuin met een oppervlakte van 49 m². Hoe lang is elke zijde?",
      "options": ["7 m", "49 m", "12 m", "14 m"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geo",
          "data": {
            "shape": "square",
            "width": 7,
            "height": 7,
            "unit": "m",
            "showGrid": true,
            "label": "Vierkante tuin: ? × ? = 49 m²"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zijde berekenen",
            "content": "Als oppervlakte = zijde × zijde, dan is de zijde = √oppervlakte. √49 = 7. Elke zijde is 7 m.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "square_side_from_area",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Als oppervlakte = zijde × zijde, dan is de zijde = √oppervlakte. De oppervlakte is 49 m². Welk getal × zichzelf = 49? Dat is 7, want 7 × 7 = 49. Elke zijde is 7 m.",
        "solutionSteps": [
          "Gegeven: oppervlakte = 49 m²",
          "Formule omdraaien: zijde = √oppervlakte",
          "Welk getal × zichzelf = 49? → 7 × 7 = 49",
          "Elke zijde is 7 m"
        ],
        "distractorExplanations": {
          "0": "Goed! √49 = 7, dus elke zijde is 7 m.",
          "1": "Je dacht waarschijnlijk dat de oppervlakte gelijk is aan de zijde. Maar 49 m² is de oppervlakte, niet de zijde. Onthoud: de zijde = √oppervlakte = √49 = 7 m.",
          "2": "Je dacht waarschijnlijk dat 12 × 12 = 49. Maar 12 × 12 = 144, niet 49. Onthoud: zoek het getal dat × zichzelf = 49. Dat is 7.",
          "3": "Je dacht waarschijnlijk dat je 49 door 2 moest delen. Maar 49 ÷ 2 = 24,5, niet 14. Onthoud: bij een vierkant deel je niet door 2, maar neem je de wortel: √49 = 7."
        }
      }
    },
    {
      "id": "MET-OPP-VIERKANT-003",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "multiple_choice",
      "question": "Een hekwerkmonteur plaatst een hek rondom een vierkant terrein met zijden van 9 cm op de plattegrond. Wat is de omtrek?",
      "options": ["36 cm", "81 cm", "18 cm", "27 cm"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geo",
          "data": {
            "shape": "square",
            "width": 9,
            "height": 9,
            "unit": "cm",
            "showGrid": false,
            "label": "Vierkant: zijde = 9 cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Omtrek vierkant",
            "content": "Formule: omtrek = 4 × zijde. Een vierkant heeft 4 gelijke zijden. Dus: 4 × 9 = 36 cm. Let op: omtrek ≠ oppervlakte! Omtrek = rondom, oppervlakte = binnenin.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "square_perimeter_vs_area",
      "variantIndex": 3,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De omtrek van een vierkant = 4 × zijde. De zijde is 9 cm, dus: 4 × 9 = 36 cm. Let op het verschil: omtrek = de rand rondom (cm), oppervlakte = het vlak binnenin (cm²). Een hek gaat rondom, dus je berekent de omtrek.",
        "solutionSteps": [
          "Lees de zijde af: 9 cm",
          "Gebruik de formule: omtrek = 4 × zijde",
          "Reken uit: 4 × 9 = 36 cm"
        ],
        "distractorExplanations": {
          "0": "Goed! 4 × 9 = 36 cm.",
          "1": "Je dacht waarschijnlijk dat je de oppervlakte moest berekenen. 81 cm² is de oppervlakte (9 × 9 = 81), niet de omtrek. Onthoud: omtrek = 4 × zijde, oppervlakte = zijde × zijde.",
          "2": "Je dacht waarschijnlijk dat een vierkant 2 zijden heeft. Maar een vierkant heeft 4 gelijke zijden: 4 × 9 = 36 cm. Onthoud: omtrek = alle zijden bij elkaar optellen = 4 × zijde.",
          "3": "Je dacht waarschijnlijk dat een vierkant 3 zijden heeft. Maar een vierkant heeft 4 zijden (een driehoek heeft er 3). Onthoud: vierkant = 4 zijden, dus omtrek = 4 × 9 = 36 cm."
        }
      }
    },
    {
      "id": "MET-OPP-VIERKANT-004",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "fill_in",
      "question": "Een glazenier maakt een vierkant raam met zijden van 8 cm. Bereken de oppervlakte in cm².",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["64", "64 cm²"],
        "placeholder": "Typ de oppervlakte...",
        "caseSensitive": false
      },
      "stimulusAids": [
        {
          "type": "geo",
          "data": {
            "shape": "square",
            "width": 8,
            "height": 8,
            "unit": "cm",
            "showGrid": true,
            "label": "Vierkant: 8 × 8 cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte vierkant",
            "content": "Oppervlakte = zijde × zijde = 8 × 8 = 64 cm².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "square_area_fill_in",
      "variantIndex": 4,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "De oppervlakte van een vierkant = zijde × zijde = 8 × 8 = 64 cm².",
        "solutionSteps": [
          "Lees de zijde af: 8 cm",
          "Gebruik de formule: oppervlakte = zijde × zijde",
          "Reken uit: 8 × 8 = 64 cm²"
        ]
      }
    },
    {
      "id": "MET-OPP-VIERKANT-005",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "multiple_choice",
      "question": "Een tegelzetter betegelt een vierkante kamer met zijden van 5 meter. Tegels kosten €12 per m². Wat kosten de tegels in totaal?",
      "options": ["€300", "€240", "€60", "€120"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geo",
          "data": {
            "shape": "square",
            "width": 5,
            "height": 5,
            "unit": "m",
            "showGrid": true,
            "label": "Kamer: 5 × 5 m"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte en kosten",
            "content": "Stap 1: Oppervlakte = 5 × 5 = 25 m². Stap 2: Kosten = 25 × €12 = €300.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "square_area_context",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Eerst de oppervlakte: 5 × 5 = 25 m². Dan de kosten: 25 m² × €12 per m² = €300. Klopt dit? 25 tegels van 1 m² à €12 = €300 ✓.",
        "solutionSteps": [
          "Bereken de oppervlakte: 5 × 5 = 25 m²",
          "Vermenigvuldig met de prijs per m²: 25 × €12 = €300",
          "Check: 25 tegels × €12 = €300 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 5 × 5 = 25 m², en 25 × €12 = €300.",
          "1": "Je dacht waarschijnlijk dat je de omtrek moest gebruiken. 4 × 5 = 20 m (omtrek), en 20 × €12 = €240. Maar tegels bedekken de vloer (oppervlakte), niet de rand. Onthoud: bij betegelen gebruik je de oppervlakte = zijde × zijde.",
          "2": "Je dacht waarschijnlijk dat je maar één zijde met de prijs moest vermenigvuldigen. 5 × €12 = €60, maar de kamer is 25 m² groot (5 × 5). Onthoud: bereken eerst de volledige oppervlakte, dan pas de kosten.",
          "3": "Je dacht waarschijnlijk dat je 2 × zijde moest gebruiken. 2 × 5 = 10, en 10 × €12 = €120. Maar de oppervlakte is 5 × 5 = 25 m². Onthoud: oppervlakte vierkant = zijde × zijde, niet 2 × zijde."
        }
      }
    }
  ]
}
